module.exports = __webpack_public_path__ + "img/0C0CC3_04049F_040483_04045C-256px.e03df921.png";